// extracted by mini-css-extract-plugin
module.exports = {"content":"src-components-sign-up-components-phone-number-errors-___errors__content___1wzZK"};